export function isScrollAtBottom(
  target: HTMLElement,
  scrollThreshold = 0
): boolean {
  const clientHeight =
    target === document.body || target === document.documentElement
      ? window.innerHeight
      : target.clientHeight;

  return (
    target.scrollTop + clientHeight >= target.scrollHeight - scrollThreshold
  );
}
